import { Link as RouterLink } from '@ovComponents/2-component/orgLink/orgLink';
import {
  ReconFlagsDetailDrawer,
  ReconFlagsFiltersCard,
  ReconFlagsGridCard,
  ReconFlagsSpotlightSummary,
  useReconFlagsPage,
} from '@ovComponents/4-module/reconFlags';
import { Box, Button, Typography, useTheme } from 'hephaestus/web';

const ReconFlagsPage = () => {
  const theme = useTheme();
  const { t, spotlightProps, filtersProps, gridProps, drawerProps } =
    useReconFlagsPage(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant='titleMedium'>
          {t('reconFlags.summaryTitle')}
        </Typography>
        <Button
          component={RouterLink}
          to='/reconciliation/flags/glossary'
          color='primary'
          size='small'
        >
          {t('flagGlossary.openGlossary')}
        </Button>
      </Box>
      <ReconFlagsSpotlightSummary {...spotlightProps} />
      <ReconFlagsFiltersCard {...filtersProps} />
      <ReconFlagsGridCard {...gridProps} />
      <ReconFlagsDetailDrawer {...drawerProps} />
    </Box>
  );
};

export default ReconFlagsPage;
